import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	$isSelected: boolean
}

export const CardRadio = styled.span<Props>`
	border: 2px solid ${helpers.color.pageHeader};
	border-radius: 50%;
	height: 27px;
	position: relative;
	width: 27px;

	&:after {
		background-color: ${helpers.color.pageHeader};
		border-radius: 50%;
		content: '';
		height: 17px;
		left: 3px;
		position: absolute;
		top: 3px;
		transform: scale(${({ $isSelected }) => ($isSelected ? 1 : 0)});
		transition: transform 100ms ease-in-out;
		width: 17px;
	}
`
